export default __webpack_public_path__ + "static/4-5cee880bb62bdd575cc99affede204be.jpg";